import * as React from "react";
import ChooseCart from "./chooseCart";
import PatientAddedInCart from "./patientsAddedInCart";
import useAuth from "@/src/lib/hooks/useAuth";
import { useSelector } from "react-redux";
import { useCustomQuery } from "@/src/lib/hooks/useFetch";
import { testApiService } from "@/src/lib/api-services/testApiServices";
import ConfirmDialog from "@/src/lib/ui/confirmDialog";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";

export default function AddTestInPatientCart() {
    const [open, setOpen] = React.useState(false);
    const [isOldProduct, setIsOldProduct] = React.useState(false);
    const isMobile = useBreakpoint("sm");
    const { isLoggedIn } = useAuth();
    const {
        data: checkoutData,
        refetch: refetchCheckoutData,
        isLoading: isCheckoutLoading,
        isFetching: isCheckoutFetching,
    } = useCustomQuery("cart", testApiService.getCart, {
        enabled: isLoggedIn && isLoggedIn,
        staleTime: 2000, // Adjust to avoid refetching too often
    });

    const isTestAddInCart = checkoutData?.data?.data?.centreCart?.data?.[0];

    const itemInCart = useSelector((state) => state?.addToCart?.addProducts);

    const isBoolean =
        isLoggedIn &&
        !!itemInCart?.centreTest?.length &&
        !!isTestAddInCart?.patients?.length;
    const handleClose = () => {
        setOpen(false);
    };

    React.useEffect(() => {
        if (isBoolean) {
            setOpen(true);
        }
    }, [isBoolean]);

    React.useEffect(() => {
        if (isLoggedIn && isTestAddInCart?.patients?.length > 0) {
            setIsOldProduct(true);
        } else {
            setIsOldProduct(false);
        }
    }, [isTestAddInCart]);

    return (
        <React.Fragment>
            <ConfirmDialog
                open={open}
                maxWidth="md"
                fullScreen={isMobile}
                content={
                    isOldProduct ? (
                        <ChooseCart
                            handleClose={handleClose}
                            isTestAddInCart={isTestAddInCart}
                            refetchCheckoutData={refetchCheckoutData}
                        />
                    ) : (
                        <PatientAddedInCart
                            handleClose={handleClose}
                            refetchCheckoutData={refetchCheckoutData}
                        />
                    )
                }
            />
        </React.Fragment>
    );
}
